import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDashboardService } from 'src/apis/dashboard/useDashboardService';
import { IPeopleDashboardData, ITimeRangeParams } from 'src/apis/dashboard/dashboard.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getDashboardPeopleKey = 'get-dashboard-people';

export const useDashboardPeopleHook = (
  params?: ITimeRangeParams,
  options?: UseQueryOptions<IPeopleDashboardData, TQueryError>
): UseQueryResult<IPeopleDashboardData, TQueryError> => {
  const { getPeopleDashboardData } = useDashboardService();

  return useQuery<IPeopleDashboardData, TQueryError>({
    queryKey: [getDashboardPeopleKey, params],
    queryFn: () => getPeopleDashboardData(params),
    enabled: true,
    ...options,
  });
};
